<div class="list-massive-payments-loads-container h-100">
  <div class="d-flex justify-content-end" *ngIf="activeSelected">
    <div class="list-select-all" select-item-list [list]="massiveLoadsList" (onSelectItem)="loadsSelected.emit($event)"
      [type]="'selectAll'">
    </div>
  </div>
  <div class="col-md-12 mb-md-0 mb-12" *ngFor="let cargo of massiveLoadsList; let i = index">
    <app-cargo-item select-item-list [cargo]="cargo"
      [selectableItem]="{isSelectable: true, isEnabled: activeSelected, errorMessage: massiveLoadsList[i].errorMessage}"
      [checked]="cargo?.checked" (onSelectItem)="loadsSelected.emit($event)" (refreshCargo)="refreshCargo($event,i)"
      [hideOptionsLoad]="true" [cargoItemList]="cargo" [typeList]="typeList" [item]="cargo" [list]="massiveLoadsList"
      [filters]="newFilters">
    </app-cargo-item>
  </div>
</div>